import { useMutation, useQuery } from "@apollo/client";
import { i18n } from "@lingui/core";
import {
  Card,
  CardSection,
  CardTitle,
  Typography,
} from "@pmberjaya/cloudbank-ui";
import { useRef, useState } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";
import { toast } from "react-toastify";
import { DELETE_CART, FETCH_CART, UPDATE_CART } from "../../../../gql/cart";
import {
  FormatRupiahCurrency,
  NumberFormat,
} from "../../../../utils/CurrencyFormat";
import { CartIcon } from "../../Icon";
const DeleteCart = (props) => {
  const { itemId } = props;
  const [deleteCartItem] = useMutation(DELETE_CART, {
    variables: {
      id: parseInt(itemId),
    },
    update(cache, results) {
      const currentCartItems = cache.readQuery({
        query: FETCH_CART,
        variables: {
          action_type: 1,
        },
      });
      const newCartItems = currentCartItems.billing_hosting.carts.filter(
        (item) => item.id !== itemId
      );
      cache.writeQuery({
        query: FETCH_CART,
        data: { billing_hosting: { carts: newCartItems } },
      });
    },
    onError(error) {
      toast(error.message, {
        type: toast.TYPE.ERROR,
        position: toast.POSITION.BOTTOM_LEFT,
      });
    },
  });

  function DeleteItemFromCart() {
    deleteCartItem();
  }

  return (
    <div
      className="icon-bin2 text-danger pt-2 btn delete-button"
      onClick={DeleteItemFromCart}
    ></div>
  );
};
// const CardContent = (props) => {
//   const { content } = props;
//   let duration = content.package_pricing_duration;

//   const [qty, setQty] = useState(content.qty);
//   const [loadingUpdate, setLoadingUpdate] = useState(false);
//   const [UpdateCartQty] = useMutation(UPDATE_CART, {
//     variables: {
//       id: content.id,
//       qty: qty,
//       package_extension_id: content.package_extension_id,
//       db: content.db,
//       // currency: currency,
//     },
//     update() {},
//     onError(error) {
//       console.log(error);
//     },
//   });
//   const [handleUpdatePrice] = useMutation(UPDATE_CART, {
//     onCompleted: () => {
//       setLoadingUpdate(false);
//     },
//   });

//   const handlePriceChange = (event, item) => {
//     setLoadingUpdate(true);
//     setQty(event.target.value);
//     handleUpdatePrice({
//       variables: {
//         id: item.id,
//         qty: event.target.value,
//       },
//     });
//   };

//   const UpdateHandler = (newQty) => {
//     return new Promise((resolve, reject) => {
//       setQty(newQty);
//       resolve();
//     });
//   };

//   const getExtension = () => {
//     let name = content.name;
//     let b = name.split(".");
//     let c = b.splice(1);
//     let d = c.join(".");

//     return d;
//   };

//   return (
//     <Card
//       className="text-start ps-2 pe-2 pt-2 mt-4 me-3 ms-3"
//       borderColor="primary"
//     >
//       <CardTitle>
//         <Typography
//           variant="h4"
//           fontWeight="bolder"
//           className="ps-3 pt-2 text-dark"
//         >
//           {" "}
//           {content.db === "vps" || content.db === "vps renew"
//             ? "Vps"
//             : content.db === "hosting" || content.db === "hosting renew"
//             ? "Hosting"
//             : "Domain"}
//         </Typography>
//       </CardTitle>
//       <CardSection>
//         <Typography className="text-paragraf-cart">
//           {content.db === "domain"
//             ? `registrasi domain .` + getExtension() + " " + content.name
//             : content.db === "vps" ||
//               content.db === "vps renew" ||
//               content.db === "vps upgrade"
//             ? content.vps_package_name + ` untuk domain ` + content.name
//             : content.package.name + ` untuk domain ` + content.name}
//           {content.cpanel ? " dengan cPanel " + content.cpanel : null}
//           <br></br>
//           Rp{" "}
//           {FormatRupiahCurrency(
//             (content.price -
//               (content.promo_discount_preview === null
//                 ? null
//                 : content.promo_discount_preview.discount)) /
//               content.qty
//           )}
//           / {content.db === "domain" ? "tahun" : "bulan"}
//           {parseInt(content.qty) < 6 && content.db === "vps" ? (
//             <Typography variant="body1">
//               Setup fee{" "}
//               {i18n.number(100000, {
//                 style: "currency",
//                 currency: "IDR",
//                 minimumFractionDigits: 0,
//               })}{" "}
//               (Sekali Bayar)
//             </Typography>
//           ) : null}
//         </Typography>

//         <select
//           className="form-select cs-full-width"
//           value={content.qty}
//           disabled={loadingUpdate}
//           // onChange={(e) =>
//           //   UpdateHandler(e.target.value).then(() => {
//           //     UpdateCartQty();
//           //   })
//           // }
//           onChange={(e) => handlePriceChange(e, content)}
//         >
//           {duration.map((mounth) => (
//             <option value={mounth}>
//               {mounth} {content.db === "domain" ? "tahun" : "bulan"}
//             </option>
//           ))}
//         </select>
//         {/* <Select

//         options=
//         /> */}

//         <p className="text-primary fs-5 pt-2">
//           <b>
//             {/* {FormatRupiahCurrency(
//               content.price -
//                 (content.promo_discount_preview === null
//                   ? null
//                   : content.promo_discount_preview.discount)
//             )} */}
//             {i18n.number(
//               parseInt(content.qty) < 6 && content.db === "vps"
//                 ? content.price -
//                     (content.promo_discount_preview === null
//                       ? null
//                       : content.promo_discount_preview.discount) +
//                     100000
//                 : content.price -
//                     (content.promo_discount_preview === null
//                       ? null
//                       : content.promo_discount_preview.discount),
//               {
//                 style: "currency",
//                 currency: "IDR",
//                 minimumFractionDigits: 0,
//               }
//             )}
//           </b>
//           <DeleteCart itemId={content.id} />
//         </p>
//       </CardSection>
//     </Card>
//   );
// };

const CartNav = () => {
  const ref = useRef();
  const isMobile = useMediaQuery({ maxWidth: 450 });
  const isMobileHeader = useMediaQuery({ maxWidth: 600 });
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const {
    loading,
    error,
    data: cardItem,
  } = useQuery(FETCH_CART, {
    variables: {
      action_type: 1,
    },
  });

  let total = 0;

  if (cardItem && cardItem.billing_hosting.carts.length > 0) {
    let Counter = 0;
    cardItem.billing_hosting.carts.map(
      (item) =>
        (Counter +=
          (parseInt(item.qty) < 6 && item.db === "vps"
            ? item.price + 100000
            : item.price) -
          (item.promo_discount_preview === null
            ? null
            : item.promo_discount_preview.discount))
    );

    total = Counter;
  }

  // const handleClick = (event) => {
  //   setShow(!show);
  //   setTarget(event.target);
  // };

  if (loading)
    return <div className="spinner-border text-light" role="status"></div>;
  if (!loading && error) return <p>Error</p>;
  if (!loading && !cardItem) return <div>xxx</div>;
  if (error) return <div>Error</div>;

  const getExtension = (name) => {
    let b = name.split(".");
    let c = b.splice(1);
    let d = c.join(".");

    return d;
  };

  return (
    <>
      <OverlayTrigger
        placement="bottom"
        trigger="click"
        key="bottom"
        rootClose
        overlay={
          <Popover className="popover-cart py-2 px-3" id="popover-contained">
            <div className="d-flex justify-content-between align-items-center">
              <h6 className="text-capitalize fw-bolder mb-0 text-secondary">
                Keranjang{" "}
                {cardItem.billing_hosting.carts.length === 0
                  ? null
                  : `(${cardItem.billing_hosting.carts.length})`}
              </h6>
              <h6
                className="btn p-0 text-capitalize fw-bolder text-end mb-0 text-primary"
                onClick={() =>
                  window.open(`${process.env.REACT_APP_NEW_DOMAIN}cart`, "_self")
                }
              >
                Lihat Sekarang
              </h6>
            </div>
            {cardItem.billing_hosting.carts.map((row) => (
              <>
                <hr className="my-1" />
                <div className="my-2 d-flex align-items-center justify-content-between">
                  <div>
                    <h6 className="fw-bolder mb-0">
                      {row.db === "vps" ||
                      row.db === "vps renew" ||
                      row.db === "vps upgrade" ||
                      row.db === "vps custom"
                        ? "VPS"
                        : row.db === "hosting" ||
                          row.db === "hosting renew" ||
                          row.db === "hosting upgrade"
                        ? "Hosting"
                        : "Domain"}
                    </h6>
                    <p className="mb-0">
                      {row.qty}{" "}
                      {row.db === "domain" ||
                      row.db === "domain renew" ||
                      row.db === "domain transfer"
                        ? "tahun"
                        : "bulan"}{" "}
                      (
                      {row.db === "domain" ||
                      row.db === "domain renew" ||
                      row.db === "domain transfer"
                        ? "." + getExtension(row.name)
                        : row.db === "vps" ||
                          row.db === "vps renew" ||
                          row.db === "vps upgrade" ||
                          row.db === "vps custom"
                        ? row.vps_package_name
                        : row.package.name}
                      )
                    </p>
                  </div>
                  <h5 className="fw-bolder text-end mb-0 text-primary">
                    {i18n.number(
                      parseInt(row.qty) < 6 && row.db === "vps"
                        ? row.price -
                            (row.promo_discount_preview === null
                              ? null
                              : row.promo_discount_preview.discount) +
                            100000
                        : row.price -
                            (row.promo_discount_preview === null
                              ? null
                              : row.promo_discount_preview.discount),
                      {
                        style: "currency",
                        currency: "IDR",
                        minimumFractionDigits: 0,
                      }
                    )}
                  </h5>
                </div>
              </>
            ))}
          </Popover>
        }
      >
        {loading ? (
          <>
            <div>
              <span>Loading...</span>
            </div>
          </>
        ) : (
          <div
            className={`btn position-relative  ${
              isMobileHeader ? "mt-2 me-1" : "mt-2 me-3"
            }`}
            onClick={() => setShow(true)}
            // ref={ref}
          >
            {/* <span className={`icon-cart  text-light fs-3`}></span> */}
            <CartIcon width="30" height="30" className="text-light" />
            {cardItem.billing_hosting.carts.length > 0 ? (
              <span className="position-absolute card-item top-0 start-100 translate-middle badge  bg-danger">
                {cardItem.billing_hosting.carts.length}
              </span>
            ) : (
              <></>
            )}
          </div>
        )}
      </OverlayTrigger>

      {/* <Offcanvas
        scroll="false"
        backdrop="true"
        position="end"
        show={show}
        onClose={() => setShow(false)}
      >
        <OffcanvasHeader></OffcanvasHeader>
        <OffcanvasBody>
          <Typography
            variant="h3"
            alignText="start"
            textTransform="uppercase"
            className=" ps-2 text-dark"
            fontWeight="bolder"
          >
            Cart ({cardItem.billing_hosting.carts.length})
          </Typography>

          {cardItem.billing_hosting.carts.length > 0 ? (
            cardItem.billing_hosting.carts.map((item) => (
              <CardContent content={item} />
            ))
          ) : (
            <div>
              <span className="icon-cart pe-3 py-3 text-primary font-80"></span>
              <Typography
                variant="h4"
                className="text-dark"
                fontWeight="bolder"
              >
                cart empty
              </Typography>
            </div>
          )}
          {cardItem.billing_hosting.carts.length > 0 ? (
            <Typography className="fs-5 text-dark fw-bolder">
              Subtotal <span>Rp {FormatRupiahCurrency(total)}</span>
            </Typography>
          ) : (
            <></>
          )}
          <Grid row justifyContent="center">
            <Button
              variant="outlined"
              color="primary"
              className="text-uppercase disable w-75"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              disabled={cardItem.billing_hosting.carts.length < 1}
              onClick={() =>
                window.open(`${process.env.REACT_APP_NEW_DOMAIN}cart`, "_self")
              }
            >
              <Typography className="fs-5 text-center m-0">
                <span className="icon-cart pe-3 "></span>Checkout
              </Typography>
            </Button>
          </Grid>
        </OffcanvasBody>
      </Offcanvas> */}
    </>
  );
};

export default CartNav;
